/**
 * @module app.waiting
 */
/** @constructor */
const waitingService = function() {

  /**
   * Number of blocking updates the application is waiting on.
   * @type {number}
   * @private
   */
  this.waitingCount = 0;

  this.increment = function() {
    this.waitingCount++;
  };

  this.decrement = function() {
    this.waitingCount--;
  };

  /**
   * Status if there are any pending blocking updates.
   * Is used to make the application appear in a waiting/loading state
   * (see style "wait").
   * @return {boolean} True if there are any pending blocking updates.
   * @export
   */
  this.isWaiting = function() {
    return this.waitingCount > 0;
  };

};

export default angular.module('appWaiting', []).service('appWaiting', waitingService);
